import React, { Component } from "react";
import IntroSection from "components/intro-section/IntroSection";
import "./Transizione.scss";

const format = (title) => {
  let arr = [];
  let exludeWords = ["e", "di"];
  arr = title.split("-");
  return arr
    .map((word, i) => {
      return exludeWords.includes(word) && i !== 0
        ? [word]
        : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

//

export default class TaskForceSud extends Component {
  //   async componentDidMount() {

  //   }
  render() {
    return (
      <div className="transizione-page">
        <IntroSection
          category={format(this.props.match.url.split("/")[1])}
          subsector={format(this.props.match.url.split("/")[2])}
          subsubsector={format(this.props.match.url.split("/")[4])}
        />
        <div className="container pad-mobile">
          <div className="title">
            <h1 style={{ marginBottom: 0 }}>Task Force Sud</h1>
            <p>Il progetto</p>
          </div>
          {/* <p>
            La Federazione ad inizio del 2021 ha predisposto il piano{" "}
            <span>Utilitalia per la transizione</span> proponendo alle Associates
            di essere partner attivi in un'azione di sistema. Utilitalia intendo
            essere un{" "}
            <span>
              attore centrale nella transizione verso un'economia innovativa,
              digitale, sostenibile, fondata su criteri di circolarità e di
              basso impatto carbonico
            </span>
            : ciò a vantaggio delle propriw Associate, dei loro stakeholder e
            del sistema economico e cosiale del Paese.
          </p>

          <div className="box-container">
            <div className="box-row">
              {boxInputs.map((box) => (
                <div className="box">
                  <h4 style={{ color: box.color, marginBottom: 8 }}>
                    {box.title}
                  </h4>
                  <div
                    style={{
                      borderLeftColor: box.color,
                      borderLeftWidth: 5,
                      borderLeftStyle: "solid",
                      paddingLeft: 8,
                      height: 148,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p>{box.body}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="box-row" style={{ marginTop: 12 }}>
              <div style={{ flex: 3 }}>
                <div className="squared-box">
                  <p>
                    Diretto riferimento agli ambiti del{" "}
                    <span>
                      <i>UE Green Deal</i> e del <i>Green Deal italiano</i>{" "}
                    </span>
                    (e alla loro implementazione), nonchè del{" "}
                    <i>Piano europeo per la finanza sostenibile,</i> cosi come
                    confermati nella <i>Roadmap for recovery</i> (post-COVID)
                  </p>
                </div>
              </div>
              <div style={{ flex: 1, marginLeft: 32 }}>
                <div className="squared-box">
                  <p>
                    Connotazione <b>fondativa e transversale</b> da rileggere
                    alla luce delle trasformazioni in atto sui merceti, della
                    rilevanza delle{" "}
                    <b>esternalità positive generate dal comparto</b> e
                    dall'obiettivo del successo sostenibile che orienta
                    l'attività d'impresa
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}
